import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CurrentUserService } from './user/current-user.service';

@Injectable({
  providedIn: 'root',
})
export class HeaderHelperService {
  constructor(private currentUserService: CurrentUserService) {}

  getHeaders(): HttpHeaders {
    const currentUser = this.currentUserService.GetSession();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${currentUser?.token}`,
    });
    return headers;
  }
}
